import axios from 'axios';
import apiConfig from '../api.config';

export default function bookingsExportRequest({ hotel, dateFrom, dateTo, lang }) {
  const {
    host,
    URIs: { bookingsExport },
  } = apiConfig;

  var filter = { dateFrom, dateTo, lang };
  if (hotel) filter.hotel = hotel;

  const uri = `${host}${bookingsExport}?filter=${JSON.stringify(filter)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        lang,
      },
      responseType: 'arraybuffer',
    })
    .then(res => {
      return res.data;
    });
}
